import { bus } from "@/main";
import { getFaqsList } from "@/data/models/faq.model";

export default {
	name: "ProjectsPage",
	data() {
		return {
			content: null,
			isReady: false,
			currentPage: 1,
		}
	},
	created () {
		this.getContent();
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	mounted () {},
	watch: {
		"$route": function () {
			this.getContent();
		}
	},
	methods: {
		getContent() {
			getFaqsList(1, 1).then(content => {
				this.faqs = content;
				this.isReady = true;
				this.totalPages = content.totalPages;
				this.totalEntries = content.totalEntries;
			});
		},
		getMoreContent(currentPage) {
			getFaqsList(1, 1).then(content => {
				this.faqs = content;
				this.totalPages = content.totalPages;
				this.totalEntries = content.totalEntries;
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/faqs/faqs.page.js